import axoisHttpUtil from "../../utils/axiosUtil";
import { ApiEndpoints } from '../../utils/utility';

export default {
  signin: async (authData) => {
    try {
      return await axoisHttpUtil.post(ApiEndpoints.SIGN_IN, authData);
    } catch (error) {
      throw error;
    }
  }
}